import React from "react";
import styled from "@emotion/styled";
import { useHistory } from "react-router-dom";
import { CrIcon } from "@maven-surface/components/base/CrIcon";

const StyledContentTitle = styled.div`
  padding: 8px 16px;
  font-family: "Noto Sans KR";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 140%;
  color: #697077;
`;

interface DrawerContentTitleProps {
  title: string;
}

const DrawerContentTitle = ({ title = "" }: DrawerContentTitleProps) => {
  return <StyledContentTitle>{title}</StyledContentTitle>;
};

const StyledContentCheck = styled(StyledContentTitle)<{ checked?: boolean; disabled?: boolean }>`
  color: ${({ checked = false, disabled = false }) => (disabled ? "#DFE2E5" : checked ? "#259AC5" : "#21272a")};
  font-size: 18px;
  display: flex;
  padding: 14px 16px;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  letter-spacing: -0.4px;
  justify-content: space-between;
  cursor: pointer;

  i {
    font-size: x-large;
  }
`;

interface DrawerContentCheckProps {
  label: string;
  checked?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

const DrawerContentCheck = ({ label, checked, disabled, onClick }: DrawerContentCheckProps) => {
  return (
    <StyledContentCheck onClick={() => onClick && onClick()} checked={checked} disabled={disabled}>
      {label}
      {checked && <CrIcon icon={"CheckMark"} />}
    </StyledContentCheck>
  );
};

const StyledContentLink = styled(StyledContentCheck)`
  cursor: pointer;
`;

interface DrawerContentLinkProps {
  label: string;
  link: string;
}

const DrawerContentLink = ({ label, link }: DrawerContentLinkProps) => {
  return (
    <StyledContentLink onClick={() => window.open(link || "/")}>
      {label}
      <CrIcon icon={{ package: "MATERIAL", name: "arrow_forward_ios" }} />
    </StyledContentLink>
  );
};

const StyledContentDivider = styled.div`
  background-color: #f5f5f5;
  width: 100%;
  height: 12px;
`;

const StyledContentDividerWrapper = styled.div`
  padding: 12px 0;
`;

const DrawerContentDivider = () => {
  return (
    <StyledContentDividerWrapper>
      <StyledContentDivider />
    </StyledContentDividerWrapper>
  );
};

const StyledContentButton = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;

const StyledContentButtonLabel = styled.label`
  width: 90%;
  text-align: center;
  color: #697077;
  font-family: "Noto Sans KR";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 135%;
  letter-spacing: -0.4px;
  padding: 17px 24px;
  border-radius: 6px;
  border: 1px solid #dfe2e5;
`;

interface DrawerContentButtonProps {
  text: string;
  link?: string;
  onClick?: () => void;
}

const DrawerContentButton = ({ text, link, onClick }: DrawerContentButtonProps) => {
  const history = useHistory();

  return (
    <StyledContentButton>
      <StyledContentButtonLabel
        onClick={() => {
          onClick && onClick();
          link && history.push(link || "/");
        }}
      >
        {text}
      </StyledContentButtonLabel>
    </StyledContentButton>
  );
};

const DrawerContent = {
  Title: DrawerContentTitle,
  Check: DrawerContentCheck,
  Link: DrawerContentLink,
  Divider: DrawerContentDivider,
  SurveyCompleteButton: DrawerContentButton,
};

export default DrawerContent;
